import { mailSend } from '../actions/mailActions';

const mailMiddleware = ({ dispatch, getState }) => next => action => {
  next(action);

  let state = getState();
  let message;
  switch(action.type){
    case 'RECORD_ADD_FORM_SUBMIT_SUCCESS':
        message = `Пользователь ${state.auth.email} добавил в базу запись с HID: ${action.payload.hid} и серийным номером ${action.payload.serial_number}`; 

        dispatch(mailSend({
            event: 'HID_SERVICE_NOTICE_ADD',
            data: {THEME:'Добавлена новая запись в базу HID', MESSAGE:message}
        }));
        break;  
    case 'RECORD_DELETE_FORM_SUBMIT_SUCCESS':
        message = `Пользователь ${state.auth.email} удалил из базы запись с HID: ${action.payload.hid} и серийным номером ${action.payload.serial_number}`; 
    
        dispatch(mailSend({
            event: 'HID_SERVICE_NOTICE_DELETE',
            data: {THEME:'Удалена запись из базы HID', MESSAGE:message}
        }));
        
        break;    
    case 'RECORD_EDIT_FORM_SUBMIT_SUCCESS':
        message = `Пользователь ${state.auth.email} изменил в базе запись с HID: ${action.payload.hid} и серийным номером ${action.payload.serial_number}`; 
    
        dispatch(mailSend({
            event: 'HID_SERVICE_NOTICE_UPDATE',
            data: {THEME:'Изменена запись в базе HID', MESSAGE:message}
        }));
        
        break;  
  }
}

export default mailMiddleware;


// WEBPACK FOOTER //
// ./src/middlewares/mailMiddleware.js